import { RouteObject } from "react-router";
import LoginScreen, { loginLoader } from "@/routes/Login";
import { TokenRedirect } from "@/routes/link/[token]";
import AcceptDelegation, {
  acceptDelegationLoader,
} from "@/routes/delegation/AcceptDelegation";
import PageError from "@/routes/PageError";
import LogoutDone from "@/routes/home/LogoutDone";
import { ROUTES } from "@/constants/routes";

export const publicRoutes: RouteObject[] = [
  {
    id: ROUTES.linkToken.id,
    path: "/link/:token",
    element: <TokenRedirect />,
  },
  {
    id: ROUTES.tilsynsLinkToken.id,
    path: "/tilsynslink/:token",
    element: <TokenRedirect />,
  },
  {
    id: ROUTES.delegationAccept.id,
    path: "/delegation/:token",
    element: <AcceptDelegation />,
    loader: acceptDelegationLoader,
    errorElement: <PageError msg="Invitationen kunne ikke hentes" />,
  },
  {
    path: "/login",
    element: <LoginScreen />,
    errorElement: <div>Error</div>,
    loader: loginLoader,
  },
  {
    path: "/Home/LogoutDone",
    id: ROUTES.logoutRedirect.id,
    element: <LogoutDone />,
  },
  {
    path: "*",
    id: ROUTES.notFoundGlobal.id,
    element: <PageError />,
  },
];
